import { render } from "./relatedList.vue?vue&type=template&id=364e6bd6&scoped=true"
import script from "./relatedList.vue?vue&type=script&lang=js"
export * from "./relatedList.vue?vue&type=script&lang=js"

import "./relatedList.vue?vue&type=style&index=0&id=364e6bd6&lang=less&scoped=true"

import exportComponent from "/var/www/html/pro-cms-dtinsights/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-364e6bd6"]])

export default __exports__